module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-contanier"
  }, [_c('header-bar', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "onLeftAction": _vm.onBack
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-panel"
  }, [_c('section', {
    staticClass: "des-panel"
  }, [_c('i', {
    staticClass: "success-icon iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('p', {
    staticClass: "success-text"
  }, [_vm._v("提交成功")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v("感谢您的申请，工作人员将会尽快与您联系")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v("成功入驻后，200元充值奖励将在5个工作日内")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v("发放到您的便利蜂账户 " + _vm._s(_vm.userPhone))])]), _vm._v(" "), _c('section', {
    staticClass: "btn",
    on: {
      "click": _vm.onGoHome
    }
  }, [_vm._v("完成")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68cc6592"}!./src/pages/Application/components/SubmitSuccess/main.html
// module id = 1518
// module chunks = 7